import React from "react";
import T from "prop-types";
import Download from "./Download";
import UnShip from "./UnShip";
import renderIf from "../../../../shared/decorators/renderIf";
import DropDown from "../../../../shared/components/DropDown/ImprovedDropDown";
import CreateCommercialInvoice from "./CreateCommercialInvoice/CreateCommercialInvoice";

function Actions({ url, shipment }) {
  return (
    <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
      <DropDown
        menuClass="dropdown-menu-right"
        buttonClasses="btn btn-info"
        buttonText="Actions"
        icon="fa fa-fw fa-caret-down"
      >
        <Download url={url} />
        <UnShip shipment={shipment} />
        <CreateCommercialInvoice shipment={shipment} />
      </DropDown>
    </div>
  );
}

export default renderIf(
  ({ shipment }) =>
    shipment.get("reference_record_line_item_type") !== "MistakeShipment"
)(Actions);

Actions.propTypes = {
  url: T.string.isRequired,
  shipment: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Actions/Actions.jsx